export const CAPTION_PRESETS = [
    {
        id: 'default',
        name: 'Simple',
        preview: {
            bg: '#222',
            color: '#fff',
            fontFamily: 'Arial, sans-serif'
        },
        description: 'Clean, standard captions'
    },
    {
        id: 'karaoke',
        name: 'Karaoke',
        preview: {
            bg: '#000',
            color: '#fff',
            border: '3px solid #fff',
            borderRadius: '6px',
            fontFamily: 'Impact, sans-serif',
            textTransform: 'uppercase'
        },
        description: 'High contrast black & white'
    },
    {
        id: 'beasty',
        name: 'Beasty',
        preview: {
            bg: '#222',
            color: '#fff',
            highlight: '#39ff14', // High-vis Neon Green
            fontFamily: 'Komika Axis, Impact, sans-serif',
            textTransform: 'uppercase',
            textShadow: '3px 3px 0 #000'
        },
        description: 'MrBeast style (Green)'
    },
    {
        id: 'deep_diver',
        name: 'Deep Diver',
        preview: {
            bg: '#fff', // White Box
            color: '#000', // Black Text
            borderRadius: '4px',
            fontFamily: 'Arial, sans-serif',
            fontWeight: '900',
            padding: '4px 8px'
        },
        description: 'Opaque background box'
    },
    {
        id: 'pod_p',
        name: 'Pod P',
        preview: {
            bg: '#222',
            color: '#fff',
            highlight: '#ff69b4', // Hot Pink
            fontFamily: 'Bogle, Montserrat, sans-serif',
            fontWeight: '900',
            textTransform: 'uppercase',
            textShadow: '2px 2px 0 #000'
        },
        description: 'Podcast style (Pink)'
    },
    {
        id: 'youshaei',
        name: 'Youshaei',
        preview: {
            bg: '#222',
            color: '#fff',
            highlight: '#00ffff', // Cyan
            fontFamily: 'Bogle, Arial Black, sans-serif',
            textTransform: 'uppercase',
            textShadow: '2px 2px 0 #000'
        },
        description: 'Teal/Cyan highlights'
    },
    {
        id: 'mozi',
        name: 'Mozi',
        preview: {
            bg: '#222',
            color: '#fff',
            highlight: '#ffea00', // Bright Yellow
            fontFamily: 'Arial, sans-serif',
            fontWeight: '900',
            textTransform: 'uppercase',
            textShadow: '2px 2px 0 #000'
        },
        description: 'Classic Yellow style'
    }
];
